import { DeviceStatus } from '../types';

const getIsDeviceSetupNeeded = (deviceStatus?: DeviceStatus | null) => {
    return deviceStatus === 'SETUP_NEEDED';
};

export default getIsDeviceSetupNeeded;
